import * as React from "react"

import { cn } from "./cn"

/**
 * The column a module page is made of: its sections, one under the other, at
 * the dashboard's distance. A module renders its page as one Stack, so the
 * spacing between areas is changed here once rather than in every module.
 */
function Stack({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot="stack" className={cn("flex flex-col gap-6", className)} {...props} />
}

export { Stack }
